import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useMemo } from 'react';
import { ModalDialog, useLocalizeMessage } from 'libs.nucleus';
export const DeleteWorkspaceSitesModal = ({ selectedSites, onClose, onDelete, isDeleting, }) => {
    const translate = useLocalizeMessage();
    const handleDelete = useCallback(async () => {
        const success = await onDelete(selectedSites);
        if (success) {
            onClose();
        }
        return success;
    }, [selectedSites, onDelete, onClose]);
    const modalBody = useMemo(() => (_jsx("div", { className: 'flex flex-col gap-4', children: _jsx("p", { className: 'text-sm text-gray-700', children: translate('Are you sure you want to delete {count} sites? This action cannot be undone.', {
                count: selectedSites.length,
            }) }) })), [translate, selectedSites.length]);
    const modalTitle = useMemo(() => translate('Confirm site deletion'), [translate]);
    const actionButtons = useMemo(() => [
        {
            label: translate('Cancel'),
            onClick: onClose,
        },
        {
            label: translate('Delete'),
            onClick: handleDelete,
            isDestructive: true,
            disabled: isDeleting,
        },
    ], [translate, onClose, handleDelete, isDeleting]);
    return (_jsx(ModalDialog, { isOpen: true, closeDialog: onClose, title: modalTitle, body: modalBody, actionButtons: actionButtons }));
};
